import { Component, Inject, OnInit } from '@angular/core';
import { BzgModalRef, BZG_MODAL_DATA } from 'bz-genome-angular';

@Component({
  selector: 'app-decrypt-modal',
  templateUrl: './decrypt-modal.component.html',
  styleUrls: ['./decrypt-modal.component.scss']
})
export class DecryptModalComponent implements OnInit {

  public password = '';

  constructor(public modalComponentRef: BzgModalRef, @Inject(BZG_MODAL_DATA) public data: any) { }

  ngOnInit() {
  }

  close() {
    this.modalComponentRef.close();
  }

  confirm() {
    this.modalComponentRef.close({
      action: 'confirm',
      password: this.password
    });
  }

}
